import type { Tx, TxOperation, TxStatus } from "@/types/dashboard";
import { record } from "@/hooks/use-api-resource";

const t = (v: unknown, f = "") =>
  v === null || v === undefined ? f : String(v);
const n = (v: unknown) => {
  const x = Number(v ?? 0);
  return Number.isFinite(x) ? x : 0;
};

export function txStatus(value: unknown): TxStatus {
  const s = t(value, "PENDING").toUpperCase();
  if (["COMPLETED", "SUCCESS", "SUCCESSFUL"].includes(s)) return "COMPLETED";
  if (["FAILED", "REJECTED", "CANCELLED", "EXPIRED"].includes(s))
    return "FAILED";
  if (["PROCESSING", "IN_RECONCILIATION"].includes(s)) return "PROCESSING";
  return "PENDING";
}
const OPS: TxOperation[] = [
  "DEPOSIT",
  "WITHDRAWAL",
  "TRANSFER_OUT",
  "TRANSFER_IN",
  "FX_CONVERSION",
  "COLLECTION",
  "PAYIN",
  "PAYOUT",
  "REFUND",
];

/** Server transaction row to the shared Tx shape (raw kept separately). */
export function toTx(raw: unknown): Tx {
  const v = record(raw);
  const meta = record(v.metadata);
  const op = t(v.operation ?? v.type, "PAYIN").toUpperCase();
  const cur = record(v.currency);
  const cty = record(v.country);
  const defaultDesc =
    op === "FX_CONVERSION" && t(meta.target_currency)
      ? `Conversion ${t(meta.source_currency || v.currency)} → ${t(meta.target_currency)} (Taux: ${t(meta.exchange_rate)}, Reçu: ${t(meta.target_amount)} ${t(meta.target_currency)})`
      : t(meta.description ?? v.description ?? v.reference_id);
  return {
    amount: n(v.amount),
    country: t(
      v.country_code ??
        cty.alpha2_code ??
        (typeof v.country === "string" ? v.country : ""),
      "INT",
    ),
    counterparty: t(
      v.phone_number ??
        meta.phone_number ??
        v.destination ??
        v.counterparty ??
        v.recipient_matricule ??
        (op === "FX_CONVERSION"
          ? `${t(meta.target_amount)} ${t(meta.target_currency)}`
          : ""),
      "—",
    ),
    createdAt: t(v.created_at ?? v.createdAt, ""),
    currency: t(
      v.currency_code ??
        cur.code ??
        (typeof v.currency === "string" ? v.currency : ""),
      "",
    ),
    description: defaultDesc,
    fee: n(
      v.fee_amount ??
        v.fee ??
        v.fees_total ??
        (typeof v.fees === "object" ? 0 : v.fees),
    ),
    method: t(
      v.payment_method ??
        v.method ??
        v.operator ??
        (op === "FX_CONVERSION" || op === "TRANSFER_OUT" || op === "TRANSFER_IN"
          ? "internal"
          : "mobile_money"),
      "mobile_money",
    ),
    operation: (OPS.includes(op as TxOperation) ? op : "PAYIN") as TxOperation,
    reference: t(v.reference ?? v.transaction_reference ?? v.id),
    status: txStatus(v.status),
    walletId: t(
      v.wallet_id ??
        v.source_wallet_id ??
        meta.source_wallet_id ??
        meta.wallet_id,
    ),
  };
}
